var React = require('react');

function ExternalLinkInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.667,13.667H4.333V4.333H9V3H4.333A1.333,1.333,0,0,0,3,4.333v9.333A1.333,1.333,0,0,0,4.333,15h9.333A1.337,1.337,0,0,0,15,13.667V9H13.667ZM10.333,3V4.333h2.393L6.173,10.887l.94.94,6.553-6.553V7.667H15V3Z","transform":"translate(-3 -3)"}));
}

ExternalLinkInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = ExternalLinkInline;

ExternalLinkInline.default = ExternalLinkInline;
